import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PILLARS } from "../data/content";

export const Pillars = () => (
  <section
    id="pillars"
    data-testid="pillars-section"
    className="py-28 md:py-40 px-6 md:px-12 max-w-[1400px] mx-auto"
  >
    <motion.p
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="text-xs tracking-[0.35em] uppercase text-samatva-plum mb-6"
    >
      The Umbrella — Seven Pillars
    </motion.p>
    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight text-samatva-ink max-w-2xl leading-[1.05] mb-16 md:mb-24"
    >
      Every dimension of a life,{" "}
      <em className="text-samatva-plum">held together.</em>
    </motion.h2>

    <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
      {PILLARS.map((p, i) => (
        <motion.a
          key={p.id}
          href={p.id === "weekly-column" ? "#column" : `/stories/${p.id}`}
          onClick={(e) => {
            if (p.id === "weekly-column") {
              e.preventDefault();
              window.__lenis?.scrollTo("#column", { duration: 1.6 });
            }
          }}
          data-testid={`pillar-${p.id}`}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
          className={`group relative ${p.span} rounded-[2rem] p-8 md:p-10 min-h-[220px] flex flex-col justify-between overflow-hidden border border-samatva-line transition-colors duration-500 ${
            p.tone === "lavender"
              ? "bg-samatva-lavender/50 hover:bg-samatva-lavender"
              : "bg-samatva-peach/60 hover:bg-samatva-peach"
          }`}
        >
          <div className="flex items-start justify-between">
            <span className="font-serif text-5xl md:text-6xl font-light text-outline opacity-40 group-hover:opacity-70 transition-opacity duration-500">
              {p.number}
            </span>
            {p.hindi && (
              <span className="font-serif text-2xl text-samatva-plum/50 italic">
                {p.hindi}
              </span>
            )}
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-serif text-2xl md:text-3xl font-medium text-samatva-ink">
                {p.title}
              </h3>
              <ArrowUpRight
                size={20}
                className="text-samatva-plum opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-300"
              />
            </div>
            <p className="mt-3 text-sm md:text-base font-light text-samatva-muted leading-relaxed max-w-md">
              {p.description}
            </p>
          </div>
        </motion.a>
      ))}
    </div>
  </section>
);
